module.exports = __webpack_public_path__ + "static/media/IMG_20160408_200839_949.a29091ab.jpg";